'use client';

import React from 'react';
import dynamic from 'next/dynamic';
import PerformanceBarChart from './PerformanceBarChart';

const WeeklyDutyChart = dynamic(() => import('./WeeklyDutyChart'), { ssr: false });

export default function DashboardCharts() {
  return (
    <div className="grid grid-cols-1 xl:grid-cols-3 gap-6 mb-6">
      <div className="xl:col-span-2 bg-card border border-border rounded-xl p-5">
        <div className="flex items-center justify-between mb-4">
          <div>
            <h3 className="text-base font-600 text-foreground">Weekly Duty Completions</h3>
            <p className="text-xs text-muted-foreground mt-0.5">Scheduled vs completed duties — last 14 days</p>
          </div>
          <div className="flex items-center gap-3 text-xs text-muted-foreground">
            <span className="flex items-center gap-1.5"><span className="w-3 h-1.5 rounded-full bg-primary inline-block" />Scheduled</span>
            <span className="flex items-center gap-1.5"><span className="w-3 h-1.5 rounded-full bg-positive inline-block" />Completed</span>
          </div>
        </div>
        <WeeklyDutyChart />
      </div>
      <div className="xl:col-span-1 bg-card border border-border rounded-xl p-5">
        <div className="mb-4">
          <h3 className="text-base font-600 text-foreground">Performance Distribution</h3>
          <p className="text-xs text-muted-foreground mt-0.5">Crew grade breakdown — current quarter</p>
        </div>
        <PerformanceBarChart />
      </div>
    </div>
  );
}